import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';

interface HeroProps {
  year: MedianIncomeYear;
}

/**
 * ① Hero — 페이지 상단의 정의 + 출처 배지. 정적 콘텐츠라 서버 컴포넌트.
 */
export const Hero = ({ year }: HeroProps) => {
  const bundle = MEDIAN_INCOME_BY_YEAR[year];

  return (
    <section className="flex flex-col gap-16 mobile-tablet:px-16">
      <h1 className="font-700 text-Gray-900 typo-h4 mobile-tablet:typo-h5">
        {year} 기준 중위소득 종합 가이드
      </h1>

      <div className="flex flex-col gap-8 rounded-small bg-Gray-50 p-16">
        <div className="font-700 text-Gray-900 typo-body3">
          &lsquo;기준 중위소득&rsquo;이란 무엇인가요?
        </div>
        <ol className="flex list-decimal flex-col gap-4 pl-20 text-Gray-700 typo-body4">
          <li>
            <strong className="font-700 text-Gray-900">기준 중위소득</strong>은
            전체 가구를 소득 순으로 줄세웠을 때 정확히 가운데(50번째) 가구의
            소득입니다.
          </li>
          <li>
            보건복지부장관이 매년 7~8월경{' '}
            <strong className="font-700 text-Gray-900">
              중앙생활보장위원회 심의·의결
            </strong>
            을 거쳐 고시합니다.
          </li>
          <li>
            기초생활보장 4대 급여(생계·의료·주거·교육)를 비롯해{' '}
            <strong className="font-700 text-Gray-900">
              14개 부처 80여 개 복지사업
            </strong>
            의 수급자 선정기준으로 활용됩니다.
          </li>
        </ol>
      </div>

      <span className="w-fit rounded-pill bg-Gray-100 px-12 py-4 text-Gray-700 typo-caption1">
        🏛 출처: {bundle.source}
      </span>
    </section>
  );
};
